import api from "./axios";

export const getIssues          = ()          => api.get("/issues");
export const getIssueById       = (id)        => api.get(`/issues/${id}`);
export const getMyIssues        = ()          => api.get("/issues/my-issues");
export const getIssuesByProject = (projectId) => api.get(`/issues/project/${projectId}`);
export const getEpicsForProject = (projectId) => api.get(`/issues/project/${projectId}/epics`);
export const getTimeBasedStats  = (params = {}) => api.get("/issues/time-stats", { params });
export const getActivities      = (id)        => api.get(`/issues/${id}/activities`);
export const getSubtasks        = (id)        => api.get(`/issues/${id}/subtasks`);

export const createIssue       = (data)          => api.post("/issues", data);
export const addComment        = (id, comment)    => api.post(`/issues/${id}/comment`, { comment });
export const updateIssue       = (id, data)       => api.put(`/issues/${id}`, data);
export const updateIssueStatus = (id, status, resolution, comment) =>
  api.put(`/issues/${id}/status`, { status, resolution, comment });
export const updateEpicStatus = (id, epic_status) =>
  api.put(`/issues/${id}/epic-status`, { epic_status });
export const reassignIssue     = (id, assignee_id, comment) =>
  api.put(`/issues/${id}/reassign`, { assignee_id, comment });
export const moveToSprint      = (id, sprint_id)  => api.put(`/issues/${id}/move-to-sprint`, { sprint_id });
export const deleteIssue       = (id)             => api.delete(`/issues/${id}`);
